import React, { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'

import { Actions, Flex, ButtonAction } from 'mailup-web-components'

import {
  STORE_KEY_FEATURES,
  notifyParent,
  storeGet,
} from 'mailup-react-helpers'
import { itemLoadingSelector } from 'Pages/CampaignsSendStatus/recoil/state/page'
import {
  stopSendingRunningCallback,
  stopSendingScheduledCallback,
  stopCampaignRunningCallback,
  stopCampaignScheduledCallback,
  recoverSendingCallback,
  moveUpSendingCallback,
  moveDownSendingCallback,
  sendingScheduleCallback,
  sendingSegmentationCallback,
  retryCheckQueueCallback,
  cancelCheckQueueCallback,
  deleteSendingCallback,
  scheduleNowCallback,
} from 'Pages/CampaignsSendStatus/recoil/callbacks/callbacks'
import { modalFasciaDiNonDisturboState } from 'Pages/CampaignsSendStatus/recoil/state/modals'
import styled from '@emotion/styled'
import {
  SENDING_SOURCE_UNDEFINED,
  SENDING_STATUS_QUEUECOMPLETED,
} from 'Constants/index'

const ButtonActionPlayContainer = styled.div`
  float: left;
  margin-right: 8px;
`

const ActionsCell = ({
  actions,
  idSending,
  idList,
  idMessage,
  idAsyncQueue,
  isBee,
  ABTestID,
  campaignId,
  campaignType,
  isStopped,
  origin,
  title,
  source,
  status,
  planningType,
}) => {
  const intl = useIntl()
  const history = useHistory()
  const stopSendingRunning = useRecoilCallback(stopSendingRunningCallback, [])
  const stopSendingScheduled = useRecoilCallback(
    stopSendingScheduledCallback,
    [],
  )
  const stopCampaignRunning = useRecoilCallback(stopCampaignRunningCallback, [])
  const stopCampaignScheduled = useRecoilCallback(
    stopCampaignScheduledCallback,
    [],
  )
  const recover = useRecoilCallback(recoverSendingCallback, [])
  const moveUp = useRecoilCallback(moveUpSendingCallback, [])
  const moveDown = useRecoilCallback(moveDownSendingCallback, [])
  const schedule = useRecoilCallback(sendingScheduleCallback, [])
  const scheduleNow = useRecoilCallback(scheduleNowCallback, [])
  const segmentation = useRecoilCallback(sendingSegmentationCallback, [])
  const retryCheckQueue = useRecoilCallback(retryCheckQueueCallback, [])
  const cancelCheckQueue = useRecoilCallback(cancelCheckQueueCallback, [])
  const deleteSending = useRecoilCallback(deleteSendingCallback, [])

  const setModalFasciaDiNonDisturboState = useSetRecoilState(
    modalFasciaDiNonDisturboState,
  )

  const openModalFasciaDiNonDisturbo = (idSending, title, idMessage) => {
    setModalFasciaDiNonDisturboState((prev) => ({
      ...prev,
      show: true,
      idSending: idSending,
      messaggeSubject: title,
      idMessage: idMessage,
    }))
  }

  const itemLoading = useRecoilValue(itemLoadingSelector(idSending))

  const { current: actionList } = useRef({
    stopRunning: {
      label: intl.formatMessage({ id: 'Load.Schedulation.ActionStop' }),
      onClick: () => {
        stopSendingRunning(idSending)
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}stop-running`,
    },
    stopScheduled: {
      label: intl.formatMessage({ id: 'Load.Schedulation.ActionStop' }),
      onClick: () => {
        stopSendingScheduled(idSending)
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}stop-scheduled`,
    },
    stopRunningCampaign: {
      label: intl.formatMessage({ id: 'Load.Schedulation.ActionStop' }),
      onClick: () => {
        stopCampaignRunning(idSending)
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}stop-campaign`,
    },
    stopScheduledCampaign: {
      label: intl.formatMessage({ id: 'Load.Schedulation.ActionStop' }),
      onClick: () => {
        stopCampaignScheduled(idSending)
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}stop-campaign`,
    },
    recover: {
      label: intl.formatMessage({
        id: 'Load.Schedulation.ActionRecover',
      }),
      onClick: () => {
        recover(idSending)
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}stop`,
    },

    scheduleNow: {
      label: intl.formatMessage({ id: 'Load.Schedulation.ActionSendNow' }),
      onClick: () => {
        scheduleNow(idSending)
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}scheduleNow`,
    },
    modifySchedule: {
      label: intl.formatMessage({ id: 'Load.Schedulation.ActionRecover' }),
      onClick: () => {
        schedule(idSending)
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}modifySchedule`,
    },
    schedule: {
      label: intl.formatMessage({ id: 'Load.Schedulation.ActionPianifica' }),
      onClick: () => {
        schedule(idSending)
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}schedule`,
    },
    moveUp: {
      label: intl.formatMessage({ id: 'Load.Schedulation.ActionMoveUp' }),
      onClick: () => {
        moveUp(idSending)
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}moveUp`,
    },
    moveDown: {
      label: intl.formatMessage({ id: 'Load.Schedulation.ActionMoveDown' }),
      onClick: () => {
        moveDown(idSending)
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}moveDown`,
    },
    fasciaDiNonDisturbo: {
      label: intl.formatMessage({
        id: 'Load.Schedulation.SendStatusMenuDnd',
      }),
      onClick: () => {
        openModalFasciaDiNonDisturbo(idSending, title, idMessage)
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}fasciaDiNonDisturbo`,
    },
    selectedRecipients: {
      label: intl.formatMessage({
        id: 'Load.Schedulation.SelectedRecipients',
      }),
      onClick: () => {
        segmentation(idSending)
      },
      separator: true,
      'data-mu-test': `${isStopped ? 'stopped-' : ''}segmentation`,
    },
    retryCheckQueue: {
      label: intl.formatMessage({ id: 'Load.Schedulation.lblRetry' }),
      onClick: () => {
        retryCheckQueue(idSending)
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}retryCheckQueue`,
    },
    cancelCheckQueue: {
      label: intl.formatMessage({ id: 'Load.Schedulation.lblCancel' }),
      onClick: () => {
        cancelCheckQueue(idSending)
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}cancelCheckQueue`,
    },
    previewQueueComplete: {
      label: intl.formatMessage({
        id: 'Load.Schedulation.lblQueuePreviewComplete',
      }),
      onClick: () => {
        notifyParent('setCurrentList', [
          idList,
          `messages_app_redirector.aspx?r=/messages/email/queue-manage/${idSending}`,
          true,
        ])
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}previewQueueComplete`,
    },
    previewQueueRunning: {
      label: intl.formatMessage({
        id: 'Load.Schedulation.lblQueuePreviewRunning',
      }),
      onClick: () => {
        notifyParent('setCurrentList', [
          idList,
          `messages_app_redirector.aspx?r=/messages/email/queue-manage/${idSending}`,
          true,
        ])
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}previewQueueRunning`,
    },
    manageABTest: {
      label: intl.formatMessage({
        id: 'Load.Schedulation.ActionManageABTest',
      }),
      onClick: () => {
        notifyParent('setCurrentList', [
          idList,
          `messages_app_redirector.aspx?r=/messages/email/abtestmanage/${ABTestID}`,
          true,
        ])
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}stop`,
    },
    manageCampaign: {
      label: intl.formatMessage({
        id: 'Load.Schedulation.ActionManageCampaign',
      }),
      onClick: () => {
        notifyParent('setCurrentList', [
          idList,
          `App.aspx#/contentsCampaignWizard/${campaignId}/4/${campaignType}`,
          true,
        ])
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}manageCampaign`,
    },
    edit: {
      label: intl.formatMessage({ id: 'Load.Schedulation.lblModifica' }),
      onClick: () => {
        notifyParent('setCurrentList', [
          idList,
          isBee
            ? `messages_app_redirector.aspx?r=/messages/email/bee/edit/${idMessage}`
            : `form_upd_newsletter.aspx?source=listemail&idNL=${idMessage}`,
          true,
        ])
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}edit`,
    },
    checkup: {
      label: intl.formatMessage({ id: 'Load.Schedulation.lblControlla' }),
      onClick: () => {
        const route = `/messages/email/${idMessage}/checkup/summary`
        notifyParent('setCurrentList', [
          idList,
          `messages_app_redirector.aspx?r=${encodeURIComponent(route)}`,
          true,
        ])
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}checkup`,
    },
    deleteSending: {
      label: intl.formatMessage({ id: 'Load.Schedulation.lblDelQueue' }),
      onClick: () => {
        deleteSending(idSending)
      },
      'data-mu-test': `${isStopped ? 'stopped-' : ''}deleteSending`,
      separator: true,
    },
  })

  const itemActions = Object.keys(actionList).reduce(
    (r, k) => (actions[k] ? [...r, actionList[k]] : r),
    [],
  )
  if (itemActions.length > 0) {
    itemActions[0].separator = false
  }

  return (
    <Flex justifyContent="flex-end" padding="24px 16px">
      <span
        className={
          'c-datatable__cell--align-right' +
          {
            'is-loading': itemLoading,
          }
        }
      >
        {!itemLoading && !!itemActions.length && (
          <>
            {origin === 'list-sending' &&
            (actions.stopRunning || actions.stopRunningCampaign) ? (
              <ButtonAction
                tooltip={intl.formatMessage({
                  id: 'Load.Schedulation.SendStatusStop',
                })}
                data-mu-test="pause-sending"
                type="pause"
                onClick={() => {
                  actions.stopRunningCampaign
                    ? stopCampaignRunning(idSending)
                    : stopSendingRunning(idSending)
                }}
              />
            ) : (
              <>
                <Actions
                  items={itemActions}
                  data-mu-test="menu_action_button"
                />
                {origin === 'list-waiting' &&
                  status === SENDING_STATUS_QUEUECOMPLETED &&
                  source !== SENDING_SOURCE_UNDEFINED &&
                  isStopped && (
                    <ButtonActionPlayContainer>
                      <ButtonAction
                        tooltip={intl.formatMessage({
                          id: 'Load.Schedulation.ReplayNow',
                        })}
                        data-mu-test="replay-sending"
                        type="play"
                        onClick={() => {
                          scheduleNow(idSending)
                        }}
                      />
                    </ButtonActionPlayContainer>
                  )}
              </>
            )}
          </>
        )}
      </span>
    </Flex>
  )
}

export default ActionsCell

ActionsCell.propTypes = {
  actions: PropTypes.any,
  idAsyncQueue: PropTypes.any,
  idSending: PropTypes.any,
  idMessage: PropTypes.any,
  idList: PropTypes.any,
  isBee: PropTypes.any,
  ABTestID: PropTypes.any,
  campaignId: PropTypes.any,
  campaignType: PropTypes.any,
  isStopped: PropTypes.bool,
  origin: PropTypes.string,
  title: PropTypes.string,
  source: PropTypes.any,
  status: PropTypes.any,
  planningType: PropTypes.any,
}
/* ,
  ({ actions: prevActions }, { actions: nextActions }) =>
    Object.entries(prevActions).reduce(
      (r, [k, v]) => r && v === nextActions[k],
      true
    )

 */
